import  { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import CustomButton from "../elements/CustomButton/CustomButton";
import { useSnackbar } from "../SnackbarContext";
import axiosInstance from "../../configuration/request";
import { formatDateToDDMMYYYY } from "../../utils/dateFormat";
import TextFieldCustom from "../elements/textfieldCustom";
import SelectCustom from "../elements/selectCustom";
import DatePickerCustom from "../elements/datePicker";
import { validateForm } from "../../utils/formValidation/validation";
import { personalInfoRules } from "../../utils/formValidation/validationRules";
import {
  buildAddressPayload,
} from "../../utils/latLongFetch";
import MapComponent from "../mapComponent";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Switch from "@mui/material/Switch";
import { TbRuler2 } from "react-icons/tb";


function CreateEmployee({ onClose, mode, employeeDetails, onSubmit }) {

  const showSnackbar = useSnackbar();
  const [formData, setFormData] = useState({
    fullName: "",
    mobile: "",
    email: "",
    birthDate: null,
    gender: "",
    addressLine1: "",
    addressLine2: "",
    landmark: "",
    city: "",
    state: "",
    zip: "",
    roles:[],
    coordinates: null,
    user_status: employeeDetails?.data?.status === "Active" ? true : false,
  });
  const [originalZip, setOriginalZip] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [mapOpen, setMapOpen] = useState(false);

  useEffect(() => {
    if (mode === "edit" && employeeDetails?.data) {
      setFormData({
        fullName: employeeDetails?.data?.name || "",
        mobile: employeeDetails?.data?.phone,
        email: employeeDetails?.data?.email.toLowerCase() || "",
        birthDate: dayjs(employeeDetails?.data?.birth_date),
        gender: employeeDetails?.data?.gender || "",
        addressLine1: employeeDetails?.data?.address?.house_no || "",
        addressLine2: employeeDetails?.data?.address?.street_address || "",
        landmark: employeeDetails?.data?.address?.landmark || "",
        city: employeeDetails?.data?.address?.city || "",
        state: employeeDetails?.data?.address?.state || "",
        zip: employeeDetails?.data?.address?.zipcode || "",
         user_status: employeeDetails?.data?.status === "Active" ? true : false,
        roles: employeeDetails?.data?.roles || [],
        coordinates: null,
      });
      setOriginalZip(employeeDetails?.data?.address?.zipcode);
    }
  }, [mode, employeeDetails]);

  const handleChange = (field) => (e) => {
    const value = e.target?.value ?? e;
    setFormData((prev) => ({ ...prev, [field]: value }));
    setFormErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSubmit = async () => {
    const errors = validateForm(formData, personalInfoRules);
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      let address = employeeDetails?.data?.address || {};
      const addressPayload = await buildAddressPayload({
        formData,
        mode,
        originalZip,
        address,
        showSnackbar,
      });

      if (!addressPayload) return;
      const payload = {
        email: formData.email.toLowerCase(),
        name: formData.fullName,
        phone_number: formData.mobile,
        dob: formatDateToDDMMYYYY(formData.birthDate),
        gender: formData.gender,
        roles: employeeDetails?.data?.roles || [],
        user_status: formData.user_status,
        // address: [addressPayload],
      };
      console.log("payload", payload);
      const isEdit = mode === "edit";
      let url;

      if (isEdit) {
        url = `customer/users/${employeeDetails?.data?.id}`;
      } else if (
        employeeDetails?.userType === "business user" &&
        employeeDetails?.shopId
      ) {
        payload.storeId = employeeDetails.shopId;
        payload.userType = "employee user";
        payload.address = addressPayload;
        url = `/customer/store/employees`;
      } else {
        payload.userType = "admin";
        url = `customer/users`;
        payload.addresses = [addressPayload];
      }
      const requestMethod = isEdit ? axiosInstance.patch : axiosInstance.post;
      requestMethod(url, payload)
        .then(() => {
          showSnackbar(
            `Permission ${isEdit ? "updated" : "created"} successfully!`,
            "success"
          );
          onSubmit();
        })
        .catch((error) => {
          if (error) {
            showSnackbar(error?.response?.data?.message, "error");
          } else {
            showSnackbar("Something went wrong!", "error");
          }
        });
    }
  };

  const handleMapSelect = (latLng) => {
    setFormData((prev) => ({ ...prev, coordinates: latLng }));
    setMapOpen(false);
  };

  return (
    <div className="py-4 px-6">
      <div className="flex justify-between mb-2">
        <div className="text-lg font-[500]">{mode === "edit" ? "Edit Employee" : "Create Employee"}</div>
        <button
          className=" text-gray-600 hover:text-black"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>
      <div className="overflow-y-auto pb-3 scrollbar-hide max-h-[500px]">
        <div className="pt-3 px-6 rounded-[16px] grid  grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-y-0 gap-x-3 items-stretch">
          <TextFieldCustom
            label="Full Name"
            fullWidth
            value={formData.fullName}
            onChange={handleChange("fullName")}
            error={!!formErrors.fullName}
            helperText={formErrors.fullName || " "}
          />

          <div className="mb-4 md:mb-0">
            <PhoneInput
              country={"us"}
              value={formData.mobile}
              onChange={(val) => handleChange("mobile")(val)}
                    inputClass="!w-full !h-[53px] !border !border-[#d1d5db] !rounded-[10px]"
              containerClass="w-full"
            />
            {formErrors.mobile && (
              <div className="text-red-600 text-xs mt-1">
                {formErrors.mobile}
              </div>
            )}
          </div>

          <TextFieldCustom
            label="Email*"
            fullWidth
            value={formData.email.toLowerCase()}
            onChange={handleChange("email")}
            error={!!formErrors.email}
            helperText={formErrors.email || " "}
          />
          <div className="mb-4 md:mb-0">
            <DatePickerCustom
              label="Birth Date*"
              value={formData.birthDate}
              onChange={handleChange("birthDate")}
              error={!!formErrors.birthDate}
              helperText={formErrors.birthDate || " "}
              maxDate={dayjs()}
            />
          </div>

          <SelectCustom
            label="Gender"
            value={formData.gender}
            onChange={handleChange("gender")}
            options={[
              { value: "male", label: "Male" },
              { value: "female", label: "Female" },
              { value: "other", label: "Other" },
            ]}
            error={!!formErrors.gender}
            helperText={formErrors.gender || " "}
          />
        </div>
        <div className="px-6 ">
          <div className="text-sm font-semibold text-gray-700 mb-3">
            Address Details
          </div>
          <div className="mt-2">
            <TextFieldCustom
              label="Address*"
              fullWidth
              value={formData.addressLine1}
              onChange={handleChange("addressLine1")}
              error={!!formErrors.addressLine1}
              helperText={formErrors.addressLine1 || " "}
              heightClass={"custom-textarea-height"}
              multiline
              rows={2}
            />
          </div>
          <div className=" grid  grid-cols-1 sm:grid-cols-2 gap-y-2 md:gap-y-0 gap-x-3 ">
            <div className="mb-4 md:mb-0">
              <TextFieldCustom
                label="Unit"
                fullWidth
                value={formData.landmark}
                onChange={handleChange("landmark")}
              />
            </div>

            <TextFieldCustom
              label="City/Town*"
              fullWidth
              value={formData.city}
              onChange={handleChange("city")}
              error={!!formErrors.city}
              helperText={formErrors.city || " "}
            />

            <TextFieldCustom
              label="State*"
              fullWidth
              value={formData.state}
              onChange={handleChange("state")}
              error={!!formErrors.state}
              helperText={formErrors.state || " "}
            />

            <TextFieldCustom
              label="Zip code*"
              fullWidth
              value={formData.zip}
              onChange={handleChange("zip")}
              error={!!formErrors.zip}
              helperText={formErrors.zip || " "}
            />
          </div>
          <div className="flex items-center gap-3 mt-2">
  <span className="text-sm font-medium text-gray-700">
    Approval Status
  </span>

  <Switch
    checked={formData.user_status === true}
    onChange={(e) =>
      setFormData((prev) => ({
        ...prev,
        user_status: e.target.checked
          ? true
          : false,
      }))
    }
    color="success"
  />

  {/* <span
    className={`text-sm font-semibold ${
      formData.isApproved 
        ? "text-green-600"
        : "text-red-600"
    }`}
  > */}
    {/* {formData.isApproved === "approved"
      ? "Approved"
      : "Rejected"} */}
  {/* </span> */}
</div>

        </div>
        
        <div className="flex justify-end">
          <CustomButton
            onClick={() => setMapOpen(true)}
            customeClass="primary-custom-button w-full xs:w-[200px] h-[40px]"
          >
            Locate on Map
          </CustomButton>
        </div>
        {mapOpen && (
          <div className="mt-3">
            <MapComponent
              isOpen={mapOpen}
              handleClose={() => setMapOpen(false)}
              address={`${formData.addressLine1}, ${formData.city}, ${formData.state}`}
              zipCode={formData.zip}
              onSelect={(coords) => handleMapSelect(coords)}
              height="300px"
            />
          </div>
        )}
      </div>

      {/* Action Buttons */}
      <div className="flex  justify-center items-center mt-8 mb-4 gap-3">
        <CustomButton
          onClick={onClose}
          customeClass="primary-custom-button w-[150px] h-[40px]"
        >
          Cancel
        </CustomButton>
        <CustomButton
          onClick={() => handleSubmit()}
          customeClass={`gradient-button w-[150px] h-[40px]`}
        >
          Submit
        </CustomButton>
      </div>
    </div>
  );
}

export default CreateEmployee;
